import { apiClient } from '@/to-fsd/shared/api';

export const getRejectCases = params => {
  return apiClient.get('/merchant/credit/credits/reject-cases', { params });
};

export const requestCreateRejectCase = params => {
  return apiClient.post(`/merchant/credit/credits/reject-cases/request-store`, params);
};

export const createRejectCase = formData => {
  return apiClient.post(`/merchant/credit/credits/reject-cases`, formData);
};

export const getRejectCase = (rejectCaseId, params) => {
  return apiClient.get(`/merchant/credit/credits/reject-cases/${rejectCaseId}`, { params });
};

export const rejectRefund = (rejectCaseId, body) => {
  return apiClient.post(`/merchant/credit/credits/reject-cases/partner-denied/${rejectCaseId}`, body);
};

export const approveRefund = rejectCaseId => {
  return apiClient.post(`/merchant/credit/credits/reject-cases/partner-approved/${rejectCaseId}`);
};

export const getRejectCaseTemplate = (applicationId, body) => {
  return apiClient.post(`/merchant/credit/credits/reject-cases/get-reject-case-template/${applicationId}`, body, {
    responseType: 'blob',
  });
};
